const responseToLabelMap = {
    '1': 'Terror',
    '1.5': 'Fear/Terror',
    '2': 'Fear',
    '2.5': 'Alarm/Fear',
    '3': 'Alarm',
    '3.5': 'Alert/Alarm',
    '4': 'Alert',
    '4.5': 'Calm/Alert',
    '5': 'Calm'
}

export const convertResponseToLabel = (response) => {
    response = Math.round(response / 0.5) * 0.5;
    return responseToLabelMap[response] ?? "Unknown";
}

const ResponseLabel = ({response}) => convertResponseToLabel(response);

export default ResponseLabel;